document.addEventListener("turbolinks:load", function () {
    const container = document.querySelector("#thankYouSuccessPage");
    if (!container) return;

    // Inject styles directly
    const style = document.createElement("style");
    style.innerHTML = `
      .fade-in {
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.6s ease-out, transform 0.6s ease-out;
      }

      .fade-in.visible {
        opacity: 1;
        transform: none;
      }
    `;
    document.head.appendChild(style);

    // Add class to children you want animated
    const fadeElements = container.querySelectorAll("h1, .text-gray-700, .border-l-4, .space-y-4, .bg-gray-100");
    fadeElements.forEach(el => el.classList.add("fade-in"));

    // Set up IntersectionObserver
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    fadeElements.forEach(el => observer.observe(el));
  });
